module.exports = __webpack_public_path__ + "static/media/AlereRx.375fa549.png";